import { Row, Col, Divider, Button, Spin, Form, Input, message } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import { DeleteOutlined, FileImageOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";

import config from "../utils/config.js";
import endpoints from "../utils/endpoints.js";

import "react-quill/dist/quill.snow.css";
import Media from "../components/Media/media.js";

function WelcomeLetter() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [mediaKey, setMediaKey] = useState(null);
  const [mediaKeyInd, setMediaKeyInd] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    handleGetData();
  }, []);

  function handleGetData() {
    setIsLoading(true);
    axios
      .get(endpoints.welcomeLetter.read)
      .then((res) => {
        console.log(res);
        res.data[0].signatures = res.data[0].signatures ? JSON.parse(res.data[0].signatures) : null;

        setData(res.data[0]);
        form.setFieldsValue(res.data[0]);

        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function handleSubmit(values) {
    setIsButtonLoading(true);

    if (values.signatures) {
      for (let i = 0; i < values.signatures.length; i++) {
        console.log(values.signatures[i]);
        if (values.signatures[i].image && values.signatures[i].image.fileList && values.signatures[i].image.fileList.length > 0) {
          values.signatures[i].image = values.signatures[i].image.fileList[0].response;
        } else {
          values.signatures[i].image = values.signatures[i].image;
        }
      }

      values.signatures = JSON.stringify(values.signatures);
    }

    axios
      .post(endpoints.welcomeLetter.update, {
        data: values,
      })
      .then((res) => {
        message.success("Carta de boas-vindas foi editada com sucesso!");
        setIsLoading(false);
        setIsButtonLoading(false);
        handleGetData();
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function closeMedia(res) {
    if (res) {
      if (mediaKeyInd !== null) form.setFieldValue([mediaKey, mediaKeyInd, "image"], res[mediaKey]);
      else form.setFieldValue(mediaKey, res[mediaKey]);
    }

    setMediaKey(null);
    setMediaKeyInd(null);
    setIsOpenMedia(false);
  }

  function openMedia(k, i) {
    setMediaKey(k);
    if (i !== null || i !== undefined) setMediaKeyInd(i);
    setIsOpenMedia(true);
  }

  return (
    <div className="dashboard-page">
      <Media mediaKey={mediaKey} open={isOpenMedia} close={closeMedia} />
      <Row className="dashboard-title-row">
        <Col span={20} className="flex justify-start items-center">
          <h3 className="dashboard-title">Carta de boas-vindas</h3>
        </Col>
        <Col span={4} className="flex justify-end items-center">
          <Button size="large" onClick={handleGetData} className="mr-2">
            <ReloadOutlined />
          </Button>
          <Button loading={isButtonLoading} size="large" type="primary" onClick={form.submit}>
            Guardar
          </Button>
        </Col>
      </Row>
      <Divider />
      <Spin spinning={isLoading}>
        <Row className="dashboard-content-row">
          <Col span={24}>
            <Form form={form} id="add-moderator-form" layout="vertical" onFinish={handleSubmit}>
              <Form.Item hidden name="id">
                <Input />
              </Form.Item>
              <Form.Item label="Texto" name="text">
                <ReactQuill className="welcome-letter" />
              </Form.Item>
              <Form.List name="signatures">
                {(fields, { add, remove, move }, { errors }) => (
                  <Row className="w-full" gutter={[24]}>
                    {fields.map((field, index) => {
                      return (
                        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues["signatures"] !== currentValues["signatures"]}>
                          {({ getFieldValue }) => {
                            console.log(getFieldValue("signatures"));
                            return (
                              <Col span={8}>
                                <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.image !== currentValues.image}>
                                  {({ getFieldValue }) => {
                                    return (
                                      <div className="relative">
                                        <p className="pb-[8px]">Imagem inicial</p>
                                        <div
                                          className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                                          onClick={() => openMedia("signatures", field.name)}
                                          style={{
                                            backgroundImage: `url(${config.server_ip}media/${getFieldValue("signatures")[field.name]?.image})`,
                                            backgroundSize: "contain",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                          }}
                                        >
                                          {!getFieldValue("signatures")[field.name]?.image ? (
                                            <div className="flex justify-center items-center flex-col p-10">
                                              <FileImageOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar Imagem</p>
                                            </div>
                                          ) : null}
                                        </div>

                                        <Form.Item name={"image"} hidden>
                                          <Input />
                                        </Form.Item>
                                      </div>
                                    );
                                  }}
                                </Form.Item>
                                <Form.Item label="Nome" name={[index, "name"]}>
                                  <Input size="large" />
                                </Form.Item>
                                <Form.Item label="Posição" name={[index, "job_title"]}>
                                  <Input size="large" />
                                </Form.Item>
                                <Form.Item className="w-full">
                                  <Button type="dashed" onClick={() => remove(index)} className="w-full" size="large" icon={<DeleteOutlined />}>
                                    Apagar
                                  </Button>
                                </Form.Item>
                              </Col>
                            );
                          }}
                        </Form.Item>
                      );
                    })}
                    <Col span={24} className="flex justify-center items-center">
                      <Button type="dashed" onClick={() => add()} className="w-full" size="large" icon={<PlusOutlined />}>
                        Adicionar assinatura
                      </Button>
                    </Col>
                    <Form.ErrorList errors={errors} />
                  </Row>
                )}
              </Form.List>
            </Form>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default WelcomeLetter;
